// convert all the code from vue2 to vue3
// https://next.vuex.vuejs.org/guide/migrating-to-4-0-from-3-x.html

// store.ts
import Vue from "vue";
import Vuex from "vuex";
import {
  VesselMonitoringRequest,
  VesselMonitoringView,
  VesselMonitoringDeck,
  VesselMonitoringResponse,
  BayList,
  ColorBy,
  VesselMonitoringContainerDetailData,
  VesselMonitoringContainerDetailResponse,
  VesselMonitoringContainerDetailRequest,
  HandlingQuayEquipmentDetailResponse,
} from "./vesselMonitoring.types";
import ApiService from "../api.service";

Vue.use(Vuex);

enum DeckEnum {
  Both = 1,
  Above = 2,
  Below = 3,
}

enum ViewEnum {
  SingleBay = 1,
  SingleColumn = 2,
  AllBays = 3,
}

interface State {
  vesselMonitoringContainerDetail:{}
  showWeightLevel:boolean;
  showWeightLevelChekbox:boolean;
  loadingMessage: string;
  finishRendering: boolean;
  isVesselMonitoringLoading: boolean;
  vesselMonitoringResponse: VesselMonitoringResponse;
  vesselMonitoringRequest: VesselMonitoringRequest;
  vesselMonitoringContainerDetailRequest: {
    containerNo: string;
    voyageId: number;
    StowageInstructionDetailCellId: number;
    loadedWrongPositionNotMatchedFields: string;
  };
  handlingQuayEquipmentDetailRequest: {
    equipmentId: number;
  };
  vesselMonitoringContainerDetailResponse: VesselMonitoringContainerDetailResponse;
  handlingQuayEquipmentDetailResponse: HandlingQuayEquipmentDetailResponse;
  isVesselMonitoringContainerDetailModalOpen: boolean;
  isHandlingQuayEquipmentDetailModalOpen: boolean;
  decks: { id: number; name: string }[];
  bayList: BayList;
  colorByList: ColorBy[];
  generateplotResponse: {};
  gantryCrane: [];
}

const state = {
  vesselMonitoringContainerDetail:{},
  showWeightLevel:false,
  showWeightLevelChekbox:true,
  loadingMessage: "loading",
  isVesselMonitoringLoading: false,
  finishRendering: false,
  isVesselMonitoringContainerDetailModalOpen: false,
  isHandlingQuayEquipmentDetailModalOpen: false,
  vesselMonitoringRequest: {
    bay: 1,
    colorBy: 1,
    deck: VesselMonitoringDeck.Both,
    status: 1,
    type: 1,
    view: ViewEnum.AllBays,
    voyageId: 1,
  },
  vesselMonitoringResponse: {
    isSuccessful: true,
    tag: "",
    deck: 1,
    message: [],
    data: {
      colorPalettes: [],
      vesselHatches: [
        {
          vesselBays: [],
          vesselProfileHatchId: 31,
        },
      ],
      vesselMonitoringType: "",
    },
  },
  generateplotResponse: {},
  vesselMonitoringContainerDetailRequest: {
    containerNo: "",
    voyageId: 1,
    stowageInstructionDetailCellId: 0,
    opretionType: 1,
    loadedWrongPositionNotMatchedFields: "",
  },
  handlingQuayEquipmentDetailRequest: {
    equipmentId: 0,
  },
  vesselMonitoringContainerDetailResponse: {
    data: {
      existed: true,
      containerNo: "",
      position: "",
      isoCode: "",
      lineOperator: "",
      containerType: "",
      length: "",
      status: "",
      height: "",
      teu: 1,
      weight: "",
      weightGroup: "",
      portOfLoad: "",
      portOfDischarge: "",
      polTerminal: "",
      podTerminal: "",
      destination: "",
      isHazardous: false,
      isOOG: false,
      bundle: false,
      isReefer: false,
    },
    isSuccessful: true,
    tag: "",
    message: [],
    errorField: "",
  },
  handlingQuayEquipmentDetailResponse: {
    data: {
      Code: "",
      ContainerNo: "",
      ContainerSize: "",
      ContainerType: "",
      POT: "",
      POL: "",
      POD: "",
      IsOOG: false,
      IsDG: false,
      IMODGClassNumber: "",
      IsFlexi: false,
      FullEmptyStatus: "",
      BayNo: "",
      VoyageOperationId: "",
      RowNo: "",
      TierNo: "",
      Status: "",
      OperationDate: "",
    },
    isSuccessful: true,
    tag: "",
    message: [],
    errorField: "",
  },
  decks: [
    {
      id: 1,
      name: "Both",
    },
    {
      id: 2,
      name: "Above",
    },
    {
      id: 3,
      name: "Below",
    },
  ],
  bayList: [],
  colorByList: [],
  gantryCrane: [],
};

const getters = {
  getIsVesselMonitoringContainerDetailModalOpen: function(state: State) {
    return state.isVesselMonitoringContainerDetailModalOpen;
  },
  getIsHandlingQuayEquipmentDetailModalOpen: function(state: State) {
    return state.isHandlingQuayEquipmentDetailModalOpen;
  },
  getVesselMonitoringContainerDetailResponse: function(state: State) {
    return state.vesselMonitoringContainerDetailResponse.data;
  },
  getHandlingQuayEquipmentDetailResponse: function(state: State) {
    return state.handlingQuayEquipmentDetailResponse.data;
  },
  getLoadingMessage: function(state: State) {
    return state.loadingMessage;
  },
  getIsVesselMonitoringLoading: function(state: State) {
    return state.isVesselMonitoringLoading;
  },
  getVesselMonitoringData: function(state: State) {
    return state.vesselMonitoringResponse.data;
  },
  getVesselMonitoringType: function(state: State) {
    return state.vesselMonitoringResponse.data.vesselMonitoringType;
  },
  getloadedWrongPositionNotMatchedFields: function(state: State) {
    return state.vesselMonitoringContainerDetailRequest
      .loadedWrongPositionNotMatchedFields;
  },
  getColorPalettes: function(state: State) {
    return state.vesselMonitoringResponse.data.colorPalettes;
  },
  getBayList: function(state) {
    return state.bayList;
  },
  getVesselMonitoringResponse: function(state: State) {
    return state.vesselMonitoringResponse;
  },
  getSelectedView: function(state: State) {
    return state.vesselMonitoringRequest.view;
  },
  getSelectedDeck: function(state: State) {
    return state.vesselMonitoringRequest.deck;
  },
  getSelectedBay: function(state: State) {
    return state.vesselMonitoringRequest.bay;
  },
  getColorByList: function(state: State) {
    return state.colorByList;
  },
  // TODO : list decks dynamically from endpoint
  getDecks: function(state) {
    return state.decks;
  },
  getSelectedColorBy: function(state: State) {
    return state.vesselMonitoringRequest.colorBy;
  },
  getShowWeightLevel: function(state: State) {
    return state.showWeightLevel;
  },
  getShowWeightLevelChekbox: function(state: State) {
    return state.showWeightLevelChekbox;
  },
  getFinishRendering: function(state: State) {
    return state.finishRendering;
  },
  getGenerateplot: function(state: State) {
    return state.generateplotResponse;
  },
  gantryCrane: function(state: State) {
    return state.gantryCrane;
  },
  getvesselMonitoringType: function(state: State) {
    return state.vesselMonitoringRequest.type;
  },
  getVesselMonitoringContainerDetail: function(state: State) {
    console.log(state.vesselMonitoringContainerDetail)
    return state.vesselMonitoringContainerDetail;
  }
};

const actions = {
  setIsVesselMonitoringLoading({ commit, state: State }, payload) {
    commit("isVesselMonitoringLoadingMutation", payload);
  },
  setLoadingMessage({ commit, state: State }, payload) {
    commit("loadingMessageMutation", payload);
  },
/*   getVesselMonitoringContainerDetail({ commit, state: State }) {
    return state.vesselMonitoringContainerDetailResponse.data;
  }, */
  fetchVesselMonitoringContainerDetail({ commit, state: State }) {
    const body = {
      ...state.vesselMonitoringContainerDetailRequest,
      voyageId: state.vesselMonitoringRequest.voyageId,
    };
    const queryStr = `?containerNo=${body.containerNo}&voyageId=${body.voyageId}&stowageInstructionDetailCellId=${body.stowageInstructionDetailCellId ?? ''}`;
    commit("isVesselMonitoringLoadingMutation", true);
    //state.vesselMonitoringContainerDetailResponse.data.filter(c=>c.containerNo = body.containerNo)
    //commit("containerDetailResponseMutation", response.data);
     
  },
  setVesselMonitoringContainerDetailRequest(
    { commit, dispatch, state: State },
    payload
  ) {    
    commit("containerDetailRequestMutation", payload);
    //dispatch("fetchVesselMonitoringContainerDetail");
    dispatch("setIsVesselMonitoringContainerDetailModalOpen", true);
  },
  setHandlingQuayEquipmentDetailRequest(
    { commit, dispatch, state: State },
    payload
  ) {
    commit("handlingQuayEquipmentDetailRequest", payload);
    dispatch("fetchhandlingQuayEquipmentDetail");
    dispatch("setIshandlingQuayEquipmentDetailModalOpen", true);
  },
  setIsVesselMonitoringContainerDetailModalOpen(
    { commit, state: State },
    payload
  ) {
    commit("isVesselMonitoringContainerDetailModalOpenMutation", payload);
  },
  setIshandlingQuayEquipmentDetailModalOpen({ commit, state: State }, payload) {
    commit("isHandlingQuayEquipmentDetailModalOpenModalOpenMutation", payload);
  },
  setVesselMonitoringContainerDetail({ commit, state: State }, payload) {
    commit("VesselMonitoringContainerDetailMutation", payload);
  },
  // Get vessel monitoring 2D bay view data
  fetchVesselMonitoring2DBayView({ commit, state: State }) {
    const body = state.vesselMonitoringRequest;
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.postCompressed(
      "system/vesseloperationmonitoring/getvesselmonitoring2dbayview",
      body
    )
      .then((response) => {
        commit("vesselMonitoring2DBayViewMutation", response);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },
  fetchVesselMonitoringBayList({ commit, state }) {
    const voyageId = state.vesselMonitoringRequest.voyageId;
    const queryStr = `?voyageId=${voyageId}`;
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.get(
      "system/vesseloperationmonitoring/getallbaybyvoyageid",
      queryStr
    )
      .then((response) => {
        commit("vesselMonitoringBayListMutation", response.data.data.bayList);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },
  fetchVesselMonitoringColorByList({ commit }) {
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.get(
      "system/vesseloperationmonitoring/getvesselmonitoringcolorby"
    )
      .then((response) => {
        commit("vesselMonitoringColorByMutation", response.data.data);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },
  // TODO Get deck types for deck dropdown
  fetchVesselMonitoringDeck({ commit }) {
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.get("system/vesseloperationmonitoring/getvesselmonitoringdeck")
      .then((response) => {
        commit("updateDecksMutation", response.data);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },
  setSelectedView({ commit, dispatch }, payload: ViewEnum) {
    commit("setSelectedViewMutation", payload);
    dispatch("fetchVesselMonitoring2DBayView");
  },
  setSelectedDeck({ commit, dispatch }, payload: DeckEnum) {
    commit("setSelectedDeckMutation", payload);
    dispatch("fetchVesselMonitoring2DBayView");
  },
  setSelectedBay({ commit, dispatch }, bay: number) {
    commit("setSelectedBayMutation", bay);
    dispatch("fetchVesselMonitoring2DBayView");
  },
  setSelectedColorBy({ commit, dispatch }, colorBy: number) {
    commit("setSelectedColorByMutation", colorBy);
    dispatch("fetchVesselMonitoring2DBayView");
  },
    setShowWeightLevel({ commit, dispatch }, payload: Boolean) {
    commit("setShowWeightLevelMutation", payload);
  },
  setShowWeightLevelChekbox({ commit, dispatch }, payload: Boolean) {
    commit("setShowWeightLevelChekboxMutation", payload);
  },
  setPropertiesFromQueryString(
    { commit, dispatch },
    { operationStatus, operationType }
  ) {
    commit("propertiesFromQueryStringMutation", {
      operationStatus,
      operationType,
    });
  },
  setFinishRendering({ commit, state: State }, payload) {
    commit("finishRenderingMutation", payload);
  },
  print({ commit, state: State }) {
    const body = state.vesselMonitoringRequest;
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.postBlob(
      "system/vesseloperationmonitoring/generateplotview",
      body
    )
      .then((response) => {
        commit("generateplotviewMutation", response.data);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },

  fetchGantryCrane({ commit, state }) {
    commit("isVesselMonitoringLoadingMutation", true);
    const voyageId = state.vesselMonitoringRequest.voyageId;
    var body = {
      EquipmentType: 102,
      EquipmentCategory: 1,
      VoyageId: voyageId,
    };
    ApiService.post(
      "tos/handlingequipment/gethandlingquayequipmentbyclass",
      body
    )
      .then((response) => {
        commit("gantryCraneMutation", response.data.data);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
      });
  },
  fetchhandlingQuayEquipmentDetail({ commit, state: State }) {
    const body = {
      ...state.handlingQuayEquipmentDetailRequest,
      voyageId: state.vesselMonitoringRequest.voyageId,
    };
    const queryStr = `?equipmentId=${body.equipmentId}&voyageId=${body.voyageId}`;
    commit("isVesselMonitoringLoadingMutation", true);
    ApiService.get(
      "tos/handlingequipment/gethandlingquayequipmentdetail",
      queryStr
    )
      .then((response) => {
        commit("handlingQuayEquipmentDetailMutation", response.data);
      })
      .finally(() => {
        commit("isVesselMonitoringLoadingMutation", false);
        commit("isHandlingQuayEquipmentDetailModalOpenModalOpenMutation", true);
      });
  },
};
const mutations = {
  VesselMonitoringContainerDetailMutation(state: State,payload: boolean) {
    state.vesselMonitoringContainerDetail = payload;
  },
  isVesselMonitoringContainerDetailModalOpenMutation(
    state: State,
    payload: boolean
  ) {
    state.isVesselMonitoringContainerDetailModalOpen = payload;
  },
  isHandlingQuayEquipmentDetailModalOpenModalOpenMutation(
    state: State,
    payload: boolean
  ) {
    state.isHandlingQuayEquipmentDetailModalOpen = payload;
  },
  containerDetailRequestMutation(state: State, payload) {
    state.vesselMonitoringContainerDetailRequest = payload;
  },
  handlingQuayEquipmentDetailRequest(state: State, payload) {
    state.handlingQuayEquipmentDetailRequest = payload;
  },
  containerDetailResponseMutation(state: State, payload) {
    state.vesselMonitoringContainerDetailResponse = { ...payload };
  },
  handlingQuayEquipmentDetailMutation(state: State, payload) {
    state.handlingQuayEquipmentDetailResponse = { ...payload };
    console.log(state.handlingQuayEquipmentDetailResponse);
  },
  loadingMessageMutation(state: State, payload) {
    state.loadingMessage = payload;
  },
  isVesselMonitoringLoadingMutation(state: State, payload) {
    state.isVesselMonitoringLoading = payload;
  },
  vesselMonitoring2DBayViewMutation(state: State, payload) {
    state.vesselMonitoringResponse = payload;
  },
  generateplotviewMutation(state: State, payload) {
    state.generateplotResponse = payload;
  },
  vesselMonitoringBayListMutation(state: State, payload) {
    state.bayList = payload;
  },
  vesselMonitoringColorByMutation(state: State, payload) {
    state.colorByList = payload;
  },
  updateDecksMutation(state: State, payload: any) {
    state.decks = payload;
  },
  setSelectedViewMutation(state: State, payload: VesselMonitoringView) {
    state.vesselMonitoringRequest.view = payload;
  },
  setSelectedBayMutation(state: State, payload: number) {
    state.vesselMonitoringRequest.bay = Number(payload);
  },
  setShowWeightLevelMutation(state: State, payload: Boolean) {
    state.showWeightLevel = Boolean(payload);
  },
    setShowWeightLevelChekboxMutation(state: State, payload: Boolean) {
    state.showWeightLevelChekbox = Boolean(payload);
  },
  setSelectedDeckMutation(state: State, payload) {
    state.vesselMonitoringRequest.deck = payload;
  },
  setVesselIdMutation(state: State, payload: number) {
    state.vesselMonitoringRequest.voyageId = payload;
  },
  setSelectedColorByMutation(state: State, payload: number) {
    state.vesselMonitoringRequest.colorBy = payload;
  },
  propertiesFromQueryStringMutation(
    state: State,
    payload: { operationStatus; operationType }
  ) {
    state.vesselMonitoringRequest.status = payload.operationStatus;
    state.vesselMonitoringRequest.type = payload.operationType;
  },
  finishRenderingMutation(state: State, payload) {
    state.finishRendering = payload;
  },
  gantryCraneMutation(state: State, payload) {
    state.gantryCrane = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
